const routes = {
	HOME: '/',
	PRICING: '/pricing',
	CAREERS: '/careers',
	WHY_FLASS: '/why-flass',
	PRIVACY: '/privacy',
	TERMS: '/terms',
	DATA_DELETION: '/data-deletion',
};

export default routes;
